import { createFieldRenderer } from '../helpers';
import classNames from 'classnames';
import React from 'react';

/**
 * The renderer used by check boxes.
 */
const CheckboxFieldRenderer = createFieldRenderer(({
    className = '',
    factory,
    innerClassName = '',
    error = null,
    label = null,
    ...props
}) => <div className={`${classNames(
    className,
    'form-group',
    'checkbox',
    {[`field-renderer-${props.name}`]: props.name },
    { 'has-error': !!error }
)} `}>
    <label className="control-label">
        {factory({
            ...props,
            className: classNames(innerClassName),
            error,
            label,
        })}
        {label}
    </label>
    {(error && typeof error === 'string') &&
        <p className="text-danger">
            {error}
        </p>
    }
</div>);

export default CheckboxFieldRenderer;
